import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import EntraGroupPicker, { EntraGroupPickerFieldSchema } from './EntraGroupPickerExtension';
import { validateEntraGroup } from './validator';

export const entraGroupPickerField = {
  name: 'EntraGroupPicker',
  component: EntraGroupPicker,
  schema: EntraGroupPickerFieldSchema,
  validation: validateEntraGroup,
};

export const EntraGroupPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...entraGroupPickerField,
    schema: EntraGroupPickerFieldSchema.schema,
  }),
);
